<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button
          id="minimizeSidebar"
          class="btn btn-icon btn-round"
          @click="minimizeSidebar"
        >
          <i
            class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"
          ></i>
          <i
            class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"
          ></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <a class="navbar-brand font-weight-bold pointer" @click="goToMain()">CentralGym: Admin Panel</a>
      <img src="/img/icons/favicon-32x32.png" alt="centralgym">
    </div>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a 
            class="nav-link btn-rotate" 
            @click="openIdeasForm"
            title="Formulario de Ideas y Mejoras"
          >
            <i class="nc-icon nc-email-85"></i>
            <p>
              <span class="d-lg-none d-md-block">Ideas</span>
            </p>
          </a>
        </li>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components/UIComponents";

export default {
  components: {
    Navbar,
    NavbarToggleButton,
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
    };
  },
  methods: {
    goToMain(){
      this.$router.push('/admin/overview')
    },
    openIdeasForm() {
      // Abre el formulario de Ideas y Mejoras de Notion en una nueva ventana
      window.open('https://ballistic-scorpio-477.notion.site/12da482ffeb88188adbbe68cfe17cec5?pvs=105', '_blank');
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
  },
};
</script>
<style scoped>
  .pointer {
    cursor: pointer;
  }
  
  /* Estilos para el botón de Ideas y Mejoras */
  .nav-link {
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .nav-link:hover {
    transform: scale(1.05);
  }
  
  .nav-link i {
    font-size: 1.3em;
  }
  
  /* Asegurar que el botón sea visible en móvil */
  @media (max-width: 991px) {
    .nav-link p {
      margin-bottom: 0;
    }
  }
</style>
